import React from 'react';
import { Shield, Star, MapPin, Handshake, PenTool, Wrench } from 'lucide-react';
export function WhyChooseUs() {
  const cards = [{
    title: 'Local Residential Glass Experts',
    copy: 'Serving Southeast Michigan homeowners with window glass, door glass, showers, mirrors, screens and custom glass projects since 2000.',
    icon: <MapPin className="w-6 h-6 text-brandBlue-600" data-id="element-219" />
  }, {
    title: 'Free In-Home Estimates',
    copy: 'Get a no-obligation estimate and clear next steps before work begins.',
    icon: <Star className="w-6 h-6 text-brandBlue-600" data-id="element-220" />
  }, {
    title: 'Glass-Only Guidance',
    copy: 'Learn whether your project needs new glass, insulated glass replacement, seal repair or full window replacement.',
    icon: <Handshake className="w-6 h-6 text-brandBlue-600" data-id="element-221" />
  }, {
    title: 'No High-Pressure Sales',
    copy: 'The team helps you understand repair, replacement and glass-only options without pressure.',
    icon: <Shield className="w-6 h-6 text-brandBlue-600" data-id="element-222" />
  }, {
    title: 'Custom Fabrication',
    copy: 'Get glass measured, ordered, fabricated or prepared for your window, door, shower, mirror, table top or custom project.',
    icon: <PenTool className="w-6 h-6 text-brandBlue-600" data-id="element-223" />
  }, {
    title: 'Warranty-Backed Work',
    copy: 'Professional residential glass repair, replacement and installation backed by warranty protection.',
    icon: <Wrench className="w-6 h-6 text-brandBlue-600" data-id="element-224" />
  }];
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-white" data-id="element-225">
      <div className="max-w-7xl mx-auto" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-227">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight" data-id="element-228">
            Why Homeowners Choose Kosin’s Glass
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-229">
          {cards.map((card, idx) => <div key={idx} className="bg-navy-800 rounded-2xl p-8 border border-navy-700" data-id="element-230">
              <div className="w-12 h-12 rounded-full bg-navy-900 border border-navy-600 flex items-center justify-center mb-6" data-id="element-231">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-232">
                {card.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-233">{card.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}